export default __webpack_public_path__ + "static/media/land-rover-svr.56eafec9.png";